import { FAQ } from "../../shared/faq";
import { navigate } from "../lib/useHashRoute";
import { IconArrowRight, IconBuilding, IconSearch, IconTeiaMark, IconUser, IconWeb } from "./Icons";

const STEPS = [
  {
    icon: <IconSearch size={18} />,
    title: "Busque do jeito que der",
    text: "Cole o CNPJ, escreva a razão social ou o nome de uma pessoa. O Teia entende os três e separa os "
      + "resultados entre empresas e sócios.",
  },
  {
    icon: <IconBuilding size={18} />,
    title: "Leia a ficha",
    text: "Situação cadastral e desde quando, endereço completo, telefones, e-mail, natureza jurídica, porte, "
      + "capital social, todos os CNAEs, regime tributário, filiais e o quadro societário.",
  },
  {
    icon: <IconUser size={18} />,
    title: "Siga as pessoas",
    text: "Clique em um sócio e veja as outras empresas dele, quem costuma aparecer junto e em quais cidades. "
      + "É o caminho para descobrir um grupo inteiro a partir de um nome.",
  },
  {
    icon: <IconWeb size={18} />,
    title: "Abra a teia",
    text: "O grafo liga empresas e pessoas camada por camada. Dá para expandir cada nó, esconder as baixadas e "
      + "procurar dentro do próprio desenho.",
  },
];


export function GuidePage() {
  return (
    <main className="page container guide-page">
      <header className="guide-hero">
        <span className="badge accent">Guia</span>
        <h1>Como consultar CNPJ grátis e descobrir os sócios</h1>
        <p className="guide-lead">
          Toda empresa brasileira tem uma ficha pública. A Receita Federal publica esses dados abertamente, e o
          Teia os organiza: quem é a empresa, quem são os sócios e o que mais essas pessoas têm. Sem cadastro,
          sem limite de consultas e sem cobrar.
        </p>
        <div className="guide-actions">
          <button className="btn btn-primary" onClick={() => navigate({ page: "home" })}>
            <IconSearch size={16} /> Consultar um CNPJ agora
          </button>
          <button className="btn btn-secondary" onClick={() => navigate({ page: "connect" })}>
            Conectar a uma IA <IconArrowRight size={15} />
          </button>
        </div>
      </header>

      <section className="guide-section">
        <h2>Em quatro passos</h2>
        <div className="step-grid">
          {STEPS.map((step, index) => (
            <article className="step-card" key={step.title}>
              <span className="step-index">{index + 1}</span>
              <span className="step-icon" aria-hidden>{step.icon}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="guide-section">
        <h2>Perguntas frequentes</h2>
        <div className="faq-list">
          {FAQ.map((item) => (
            <details className="faq-item" key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </section>

      <section className="connect-cta">
        <span className="connect-cta-mark" aria-hidden><IconTeiaMark size={30} /></span>
        <div>
          <h2>Quem está por trás do CNPJ?</h2>
          <p>Comece pelo número, pelo nome da empresa ou pelo nome de uma pessoa.</p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate({ page: "home" })}>
          <IconSearch size={16} /> Buscar
        </button>
      </section>
    </main>
  );
}
